import React, { useState, useEffect } from 'react';
import FeedbackMessage from '@ta-interaktiv/react-feedback-message';
import { ShareButtons } from '@ta-interaktiv/react-share-buttons';
import { CopyrightNotice } from '@ta-interaktiv/react-copyright-notice';
import { UserFeedback } from '@ta-interaktiv/react-user-feedback';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css';
import { Waypoint } from 'react-waypoint';
import { getLanguage, getPublishingDate } from '@ta-interaktiv/api-access';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".footer-module_footer__2we6K {\n  --font-size: 0.9rem; }\n\n.footer-module_inverted__9OKzW {\n  --strong-transparent-black: rgba(255, 255, 255, 0.33); }\n\n.footer-module_sharing__n4BUy {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-box;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n     -moz-box-orient: vertical;\n     -moz-box-direction: normal;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n     -moz-box-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n     -moz-box-pack: center;\n          justify-content: center; }\n\n.footer-module_sharingTitle__hKXar.footer-module_sharingTitle__hKXar.footer-module_sharingTitle__hKXar.footer-module_sharingTitle__hKXar {\n  margin-bottom: 1ex !important;\n  color: var(--text-color); }\n\n.footer-module_creditsTable__qCaJd {\n  font-size: var(--font-size) !important; }\n";
var styles = {"footer":"footer-module_footer__2we6K","inverted":"footer-module_inverted__9OKzW","sharing":"footer-module_sharing__n4BUy","sharingTitle":"footer-module_sharingTitle__hKXar","creditsTable":"footer-module_creditsTable__qCaJd"};
styleInject(css_248z);

var css_248z$1 = ".portfolioTeaser-module_portfolioTeaser__2cFvm {\n  display: block !important; }\n";
var styles$1 = {"portfolioTeaser":"portfolioTeaser-module_portfolioTeaser__2cFvm"};
styleInject(css_248z$1);

var PortfolioTeaser = function (_a) {
    var mediaName = _a.mediaName;
    var domain = mediaName || parseHostname().publicationName;
    return (React.createElement("a", { href: "https://" + domain + ".ch/567956067068", className: "ui medium centered image " + styles$1.portfolioTeaser },
        React.createElement("img", { src: 'https://interaktiv.tagesanzeiger.ch/inline-teaser.gif', className: 'portfolio-teaser', alt: 'Die besten Arbeiten des Interaktiv-Teams: Zur Sammlung' })));
};

var data = { sharingTitle:"Partager l'article",
  published:"Publication" };

var data$1 = { sharingTitle:"Beitrag teilen",
  published:"Veröffentlicht" };

var data$2 = { sharingTitle:"Share this article",
  published:"Published" };

var ScrollTracking = function (_a) {
    var eventLabel = _a.eventLabel;
    return (React.createElement(Waypoint, { scrollableAncestor: window, onEnter: function (_a) {
            var previousPosition = _a.previousPosition;
            if (previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'Interactions',
                    event_action: 'vertical-scroll',
                    event_label: eventLabel
                });
            }
        } }));
};

var _a;
var messages = {
    de: data$1,
    fr: data,
    en: data$2
};
var defaultPublishingDate = new Date((((_a = window.project) === null || _a === void 0 ? void 0 : _a.buildTimestamp) || 0) * 1000).toISOString();
var Footer = function (_a) {
    var additionalShares = _a.additionalShares, articleId = _a.articleId, call = _a.call, credits = _a.credits, displayPrivacyPolicyLink = _a.displayPrivacyPolicyLink, fullMediaName = _a.fullMediaName, inverted = _a.inverted, locale = _a.locale, mailTo = _a.mailTo, mediaName = _a.mediaName, project = _a.project, question = _a.question, questions = _a.questions, starColor = _a.starColor, title = _a.title, _b = _a.hidePortfolioTeaser, hidePortfolioTeaser = _b === void 0 ? false : _b, _c = _a.hideUserFeedback, hideUserFeedback = _c === void 0 ? false : _c, _d = _a.hideBottom, hideBottom = _d === void 0 ? false : _d, _e = _a.hideTop, hideTop = _e === void 0 ? false : _e, year = _a.year, _f = _a.topHalfClassName, topHalfClassName = _f === void 0 ? '' : _f, _g = _a.bottomHalfClassName, bottomHalfClassName = _g === void 0 ? 'grey' : _g, children = _a.children, invertedTop = _a.invertedTop, invertedBottom = _a.invertedBottom;
    var _h;
    var domain = mediaName === 'sonntagszeitung' || mediaName === 'dasmagazin'
        ? 'tagesanzeiger'
        : mediaName || parseHostname().publicationName;
    var _j = useState(((_h = window.document.documentElement
        .getAttribute('lang')) === null || _h === void 0 ? void 0 : _h.split('-')[0]) || 'de'), dynamicLocale = _j[0], setLocale = _j[1];
    var _k = useState(defaultPublishingDate), publicationDate = _k[0], setPublicationDate = _k[1];
    useEffect(function () {
        getLanguage(domain).then(function (lang) {
            if (lang)
                setLocale(lang);
        });
    }, [domain]);
    useEffect(function () {
        getPublishingDate(domain, articleId).then(function (pubDate) {
            setPublicationDate(pubDate);
        });
    }, [articleId, domain]);
    locale = locale || dynamicLocale;
    var copyrightNoticeProps = {
        displayPrivacyPolicyLink: displayPrivacyPolicyLink,
        fullMediaName: fullMediaName,
        inverted: inverted || invertedBottom,
        locale: locale,
        mediaName: mediaName,
        year: year
    };
    var portfolioTeaserProps = {
        mediaName: mediaName
    };
    var feedbackMessageProps = {
        call: call,
        inverted: inverted || invertedTop,
        locale: locale,
        mailTo: mailTo,
        project: project,
        question: question
    };
    var shareButtonProps = {
        articleId: articleId,
        additionalShares: additionalShares
    };
    var userFeedbackProps = {
        articleId: articleId,
        inverted: inverted || invertedTop,
        locale: locale,
        questions: questions,
        title: title,
        starColor: starColor
    };
    var sharingTitleClasses = "ui sub header " + styles.sharingTitle;
    sharingTitleClasses += inverted ? ' inverted' : '';
    var topHalfClasses = inverted || invertedTop
        ? "inverted " + styles.inverted + " " + topHalfClassName
        : topHalfClassName;
    var bottomHalfClasses = inverted || invertedBottom
        ? "inverted " + styles.inverted + " " + bottomHalfClassName
        : bottomHalfClassName;
    var tableClass = inverted || invertedBottom ? 'inverted' : '';
    var dateTimeFormatter = new Intl.DateTimeFormat(locale + '-CH', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    });
    return (React.createElement("footer", { className: "standalone-footer " + styles.footer },
        React.createElement(ScrollTracking, { eventLabel: 'contentBottom' }),
        !hideTop && (React.createElement("div", { className: "ui vertical segment topHalf " + topHalfClasses },
            React.createElement("div", { className: 'ui text infographic container' },
                React.createElement("aside", { className: "ui vertical very fitted basic segment " + styles.sharing },
                    React.createElement("div", { className: sharingTitleClasses },
                        messages[locale].sharingTitle,
                        ":"),
                    React.createElement(ShareButtons, __assign({}, shareButtonProps))),
                !hideUserFeedback && (React.createElement("aside", { className: 'ui vertical very fitted basic segment' },
                    React.createElement(UserFeedback, __assign({}, userFeedbackProps)))),
                React.createElement(FeedbackMessage, __assign({}, feedbackMessageProps))))),
        children,
        !hideBottom && (React.createElement("div", { className: "ui vertical secondary segment bottomHalf " + bottomHalfClasses },
            React.createElement("div", { className: 'ui text container' },
                !hidePortfolioTeaser && (React.createElement(PortfolioTeaser, __assign({}, portfolioTeaserProps))),
                React.createElement("table", { className: "ui very basic fixed " + tableClass + " definition infographic table " + styles.creditsTable },
                    React.createElement("tbody", null,
                        credits.map(function (row, rowIndex) { return (React.createElement("tr", { key: "credits-" + rowIndex, className: 'top aligned' }, row.map(function (cell, cellIndex) { return (React.createElement("td", { className: 'eight wide', key: "credits-" + rowIndex + "-" + cellIndex, dangerouslySetInnerHTML: { __html: cell } })); }))); }),
                        publicationDate && (React.createElement("tr", null,
                            React.createElement("td", null, messages[locale].published),
                            React.createElement("td", null, dateTimeFormatter.format(new Date(publicationDate))))))),
                React.createElement(CopyrightNotice, __assign({}, copyrightNoticeProps))))),
        React.createElement(ScrollTracking, { eventLabel: 'pageBottom' })));
};

export default Footer;
export { Footer };
//# sourceMappingURL=index.js.map
